// Sprachabhängige Formate (Datum, Zahl, Prozent) für Oberfläche und Exporte

/**
 * Locale für Datums- und Zahlenformate nach UI-Sprache: Schweizer Varianten (de-CH «12.6.2026», «55.3»;
 * fr-CH «12.06.2026», «55,3»), Englisch britisch (TT/MM/JJJJ) statt amerikanisch.
 */
export const uiLocale = (lang?: string): string => {
    switch ((lang || 'de').slice(0, 2)) {
        case 'fr': return 'fr-CH';
        case 'it': return 'it-CH';
        case 'en': return 'en-GB';
        default: return 'de-CH';
    }
};

/** Zahl nach UI-Sprache, höchstens eine Nachkommastelle (fr-CH «55,3»). */
export const formatNumber = (value: number, lang?: string): string =>
    new Intl.NumberFormat(uiLocale(lang), { maximumFractionDigits: 1 }).format(value);

/** Prozentwert nach UI-Sprache mit geschütztem Leerzeichen vor «%», im Englischen ohne (fr-CH «55,3 %»). */
export const formatPercent = (value: number, lang?: string): string =>
    `${formatNumber(value, lang)}${(lang || 'de').startsWith('en') ? '' : '\u00a0'}%`;
